export const selectModule = (state) => state.module.property

export const selectIsInitialized = (state) => selectModule(state).init

export const selectEntries = (state) => selectModule(state).entries

export const selectEntryByKey = (state) => (key) =>
  selectModule(state).entries.find((v) => v.key === key)
